import React, { useContext, useEffect } from "react";
import { decode } from "html-entities";
import { GlobalContext } from "../context/GlobalContext";

export default function EditorSlot(props) {
  const editorPicture = props.editor.picture || "avatar.png";
  const { settings } = useContext(GlobalContext);
  const [hide, setHide] = React.useState(false);

  useEffect(() => {
    const journals = [
      "www.botanyjournals.com",
      "www.ecologyjournal.in",
      "www.agriculturejournal.in",
      "www.entomologyjournals.com",
      "www.foodsciencejournal.com",
    ];
    journals.includes(settings.domain) ? setHide(true) : setHide(false);
  }, [settings]);

  return (
    <div className="flex border-t-2 border-blue-600">
      <div className="w-1/6 p-2 border-r-2 border-blue-600">
        <img src={`assets/editors/${editorPicture}`} />
      </div>
      <div className="w-5/6 p-2">
        <div>
          <b>{props.editor.name}</b>&nbsp;
          {props.editor.degree !== "" && <>({props.editor.degree})</>}
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: decode(props.editor.post) }}
        ></div>
        <div>{props.editor.content}</div>
        {hide && (
          <div>
            <b>Email: </b>
            {props.editor.email}
          </div>
        )}
        {hide && (
          <div>
            <b>Phone: </b>
            {props.editor.phone}
          </div>
        )}
      </div>
    </div>
  );
}
